const selectors = {
    cartCheckout: document.querySelector('[data-checkout-btn]'),
    checkoutSticky: document.querySelector('.checkoutbtn-sticky')
};

class templateCartJS {
    constructor() {
        var warrantyButtons = document.querySelectorAll('[data-product-warranty-addon]');
        if(warrantyButtons.length > 0) this.warrantyChecker(warrantyButtons);
        this.cartElement = document.querySelector('ajax-cart');
        selectors.cartCheckout.addEventListener("click", (event)=>{
            event.preventDefault();
            var objArray = [];           
            window.globalVariables.cart.items.forEach(item=>{
               let obj = {
                  item_id: `"${item.id}"`,
                  item_name : `"${item.product_title}"`,
                  quantity :`"${item.quantity}"`,
                  price : `${item.price/100}`
                };
                objArray.push(obj);
              });
              console.log("objArray",objArray)
          
            gtag("event", "begin_checkout", {
                currency: "USD",
                value: window.globalVariables.cart.total_price / 100,
                items: objArray
            });
          window.location.href="/checkout"

        });
    }

    // function which return the rendom number
    makeid(length) {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        let counter = 0;
        while (counter < length) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength));
          counter += 1;
        }
        return result;
    }

    // warranty checker
    warrantyChecker(warrantyButtons) {
        const that = this;
        warrantyButtons.forEach(item => {
            item.addEventListener('change', e => {
                e.preventDefault();
                item.closest('.add-meisner')?.classList.add('disabled');
                // check customer is eligible for warranty or not, by zip code
                var customerIsEligible = false;
                if (document.body.classList.contains('no-zipcode-validate-before-warranty')) {
                    document.querySelector('#PopupModal-check-availability .modal')?.classList.add('open');
                    siteOverlay.prototype.showOverlay();
                    item.setAttribute('current-attribute-for-warranty', true);
                } else {
                    var customerIsEligible = true;
                }
                if (customerIsEligible) {
                    var warrantyLine = item.dataset.line;
                    var warrantyQuantity = item.dataset.quantity;
                    var warrantyVariant = item.dataset.warranty;
                    var randomNumber = that.makeid(10);
                    
                    const body = JSON.stringify({
                        'line': warrantyLine,
                        'quantity': warrantyQuantity,
                        'properties': { 'Warranty Added': true, '_Warranty Token': randomNumber }
                    });
            
                    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body }})
                    .then((response) => { return response.json(); })
                    .then((data) => {
                        const bodySecond = JSON.stringify({
                            'id': warrantyVariant,
                            'quantity': warrantyQuantity,
                            'properties': { '_Warranty Ref': true, '_Warranty Token': randomNumber }
                        });
                
                        fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body: bodySecond }})
                        .then((response) => { return response.json(); })
                        .then((data) => {
                            this.cartElement.getCartData();
                            item.closest('.add-meisner')?.classList.remove('disabled');
                        }).catch((error) => { console.error(error); });
                    }).catch((error) => { console.error(error); });   
                }
            })
        })
    }
}

typeof templateCartJS !== 'undefined' && new templateCartJS();
